import type { FolderContentsItemsCount, Image, Metadata } from "./content";

export type BundleContext = {
	numericId: number;
	contentId?: number;
	name: string;
	id: string;
	career?: {
		label: string;
		thumbnail: string;
	};
};

export type Plan = {
	id: number;
	name: string;
	originalAmount: number;
	amount: number;
	logicalId: string;
	currency: string;
	interval: string;
	duration: number;
	isMobile: boolean;
	alias: string;
};

export type ProductType = "STUDY_PACK" | "PRACTICE_TEST" | "EXAM" | "DIRECT";
export type Bundle = {
	id: string;
	numericId: number;
	name: string;
	logicalId: string;
	examId: string;
	examUUID: string;
	examName: string;
	isActive: boolean;
	description: string;
	tagline: string;
	icon: Image;
	created: string;
	isPublished: boolean;
	categories: string[];
	features: string[];
	featuresMandarin: string[];
	featuresJapanese: string[];
	media: Image[];
	plans: Plan[];
	purchasable?: boolean;
	bundleType: ProductType;
	bundleSubType: ProductType;
	isMobileOnly: boolean;
	contentsItemsCount?: FolderContentsItemsCount;
	numTrialDays: number;
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	contents: any;
};
type BundleTrial = {
	isOpted: boolean;
	status: string;
	startDate: string;
	endDate: string;
};
type BundleSubscription = {
	status: string;
	isLegacy: boolean;
	startDate: string;
	endDate: string;
	hasRenewed: boolean;
};
export interface BundleMetaData extends Metadata {
	trial: BundleTrial;
	subscription: BundleSubscription;
}
export type BundleDetails = {
	bundle: Bundle;
	metadata: BundleMetaData;
	id?: string;
};
